/**
 * UC-05: AdvanceResearch
 * TOGAF Application ABB — progress tech tree without UI deps.
 */
import { TECH_TREE } from '../../../constants';
import type { ResearchState } from '../../../types';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { AdvanceResearchInput, AdvanceResearchOutput } from '../dto/AdvanceResearchDto';

export interface AdvanceResearchDependencies {
  logger?: IAppLogger;
}

export class AdvanceResearchUseCase {
  constructor(private readonly deps: AdvanceResearchDependencies = {}) {}

  execute(input: AdvanceResearchInput): AdvanceResearchOutput {
    const { research } = input;

    if (!research.activeResearchId) {
      return { research };
    }

    const tech = TECH_TREE.find((t) => t.id === research.activeResearchId);
    if (!tech) {
      return { research };
    }

    const newProgress = research.researchProgress + 1 / tech.duration;

    if (newProgress >= 1) {
      const levelBoost = tech.effects?.maxLevelIncrease || 0;
      const updatedResearch: ResearchState = {
        ...research,
        activeResearchId: null,
        researchProgress: 0,
        completedTechs: [...research.completedTechs, tech.id],
        unlockedBuildings: [...research.unlockedBuildings, ...tech.unlocks],
        currentMaxLevel: research.currentMaxLevel + levelBoost,
      };

      this.deps.logger?.log('debug', 'research.completed', {
        techId: tech.id,
        techName: tech.name,
      });

      return {
        research: updatedResearch,
        completedTechId: tech.id,
        newsMessage: `R&D COMPLETE: ${tech.name} unlocked.`,
      };
    }

    return {
      research: {
        ...research,
        researchProgress: newProgress,
      },
    };
  }
}